import { render, staticRenderFns } from "./OrdersFormPaymentConfirm.vue?vue&type=template&id=75775a80&scoped=true&"
import script from "./OrdersFormPaymentConfirm.vue?vue&type=script&lang=js&"
export * from "./OrdersFormPaymentConfirm.vue?vue&type=script&lang=js&"
import style0 from "./OrdersFormPaymentConfirm.vue?vue&type=style&index=0&id=75775a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75775a80",
  null
  
)

export default component.exports